import * as React from 'react';

import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import './style.css';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/material/Grid';
// import SearchField from "react-search-field";
import wagefitlogo from "../../assets/wagefitlogo.png";
import UserLogo from "../../assets/Image1-users-size24.png";
import UserFeedbackLogo from "../../assets/Image1-users feedback-size24.png";
import EmployeeLogo from "../../assets/Image1-employee-size24.png";
import PriceManagementLogo from "../../assets/Image1-price management-size24.png";
import Partner from "../../assets/Partner.png";
import employee from "../../assets/employee.png";
import DashboardIcon from '@mui/icons-material/Dashboard';
import PieChartIcon from '@mui/icons-material/PieChart';
import SettingsIcon from '@mui/icons-material/Settings';
import HelpIcon from '@mui/icons-material/Help';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
// import LogoutIcon from '@mui/icons-material/Logout';
import { NavLink } from 'react-router-dom';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

// import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
// import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
// import PersonAdd from '@mui/icons-material/PersonAdd';
// import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import LockResetOutlinedIcon from '@mui/icons-material/LockResetOutlined';
import PersonIcon from '@mui/icons-material/Person';
import { CommunicationService } from '../../services/communication-service';
import { toast } from 'react-toastify';
// import report from "../../assets/report.png";
import deduction from "../../assets/deduction.png";
import ExploreIcon from '@mui/icons-material/Explore';
import { confirm } from 'react-confirm-box';
import { useEffect } from 'react';


const drawerWidth = 240;
function ResponsiveDrawer(props) {
  const userInfo = JSON.parse(localStorage.getItem('loginUser'))
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [partnerName, setPartnerName] = React.useState('Partner');
  const history = props.customProps.history
  let isLoggedIn = '';
  const loginuserroles = localStorage.getItem('ACCESS_TOKEN') && JSON.parse(localStorage.getItem('loginUser')).roles
  if (localStorage.getItem('ACCESS_TOKEN') && JSON.parse(localStorage.getItem('loginUser')).is_onboarded) {
    isLoggedIn = localStorage.getItem('ACCESS_TOKEN')
  }
 
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
    if(localStorage.getItem('loginUser') && JSON.parse(localStorage.getItem('loginUser')).roles != 1 ){
      setPartnerName(JSON.parse(localStorage.getItem('loginUser')).first_name)
    }
    else{
      setPartnerName('Partner')
    }
  },[props])

  const logout = (route) => {
    CommunicationService.setLoggedInSatus(false)
    localStorage.removeItem("ACCESS_TOKEN");
    localStorage.removeItem("REFRESH_TOKEN");
    localStorage.removeItem("loginUser");
    localStorage.removeItem("Inactive");
    localStorage.clear()
    history.push(route)
  }

  if(localStorage.getItem('Inactive')){
    toast.error('Your account is inactive.Please contact support team')
    logout()
  }


  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const deductionNavigation = () => {
    localStorage.removeItem('selectedEmployerReport')
  }

  function goToPageClick(route) {
    history.push(route)
  }

  const openConfirmDialog = async () => {
    const message = 'Are you sure, you want to ' + ' Logout?';
    const options = {
        title: "Confirm",
        labels: {
            confirmable: "Confirm",
            cancellable: "Cancel"
        },
        closeOnOverlayClick: false
    }
    const result = await confirm(message, options);
    if (result) {
      logout('/login')
    }
    console.log("You click No!");
};

  const drawer = (

    <div className='SideNavBarDrawer'>

      <div className='wagefitLogo'>
        <img src={wagefitlogo} alt="logo" />
      </div>
      <div className='PartnerLogo'>
        {/* <img src={Partner} alt="logo" /> */}
        <div className='PartnerLogoText'>{partnerName}</div>
      </div>


      <List>
        <NavLink to="/dashboard" activeClassName='active' className='CommonDiv'><DashboardIcon />
          <Typography className='dashboardText' component={'span'}>Dashboard</Typography>
        </NavLink>

        {loginuserroles === 1 &&
          <NavLink to="/admin-users/1" activeClassName='active' className='CommonDiv'>
            <AdminPanelSettingsIcon/><Typography className='dashboardText' component={'span'}> Admin Users</Typography>
          </NavLink>
        }

        <NavLink to="/users-list/1" activeClassName='active' className='CommonDiv'>
        <img src={UserLogo} className='dataExchngeImg' alt="logo" />
        <Typography className='dashboardText' component={'span'}> Users</Typography>
        </NavLink>

        <Accordion className='removeBorder AccordionSummaryDiv'>
          <AccordionSummary className='subAccordian'
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            {/* <img src={dataExchange} className='dataExchngeImg' alt="logo" /> */}
            <PieChartIcon style={{ marginRight: "5%" }} />
            <Typography component={'span'}>Data Exchange</Typography>
          </AccordionSummary>
          {(loginuserroles === 1 || loginuserroles === 4) &&
            <Accordion className='AccordionSummaryDiv subMenuDiv'>

              <AccordionSummary className='typoEmployer'
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <img src={employee} className='dataExchngeImg' alt="logo" />
                <Typography component={'span'} className='typoTxt'>Employer</Typography>
              </AccordionSummary>

              <AccordionDetails className='secondContentPaddingTB'>
                <Typography component={'span'}>
                  <ul className='ulList'>
                    <li>
                      <NavLink to="/manage-employer-files-list/1" activeClassName='active' className='CommonDiv'>
                        <FileUploadOutlinedIcon /> <Typography className=' ul_li_height' component={'span'}> Upload Employer </Typography>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/employer-list/1" activeClassName='active' className='CommonDiv'>
                        <ManageAccountsIcon /> <Typography className=' ul_li_height' component={'span'}> Manage Employer </Typography>
                      </NavLink>
                    </li>
                  </ul>

                </Typography>
              </AccordionDetails>
            </Accordion>
          }


          <Accordion className='AccordionSummaryDiv subMenuDiv' loginuserroles={1 || 2 || 3}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <img src={EmployeeLogo} className='dataExchngeImg' alt="logo" />
              <Typography component={'span'} className='typoTxt'>Employee</Typography>
            </AccordionSummary>
            <AccordionDetails className='secondContentPaddingTB'>
              <Typography component={'span'}>
                <ul className='ulList'>
                  <li>
                    <NavLink to="/manage-employee-files-list/1" activeClassName='active' className='CommonDiv'>
                      <FileUploadOutlinedIcon /> <Typography className=' ul_li_height' component={'span'}> Upload Employee </Typography>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/employee-list/1" activeClassName='active' className='CommonDiv'>
                      <ManageAccountsIcon /> <Typography className=' ul_li_height' component={'span'}> Manage Employee </Typography>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-earning-files-list/1" activeClassName='active' className='CommonDiv'>
                      <FileUploadOutlinedIcon /> <Typography className=' ul_li_height' component={'span'}> Upload Earning</Typography>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/earning-list/1" activeClassName='active' className='CommonDiv'>
                      <ManageAccountsIcon /> <Typography className=' ul_li_height' component={'span'}> Manage Earnings </Typography>
                    </NavLink>
                  </li>
                </ul>

              </Typography>
            </AccordionDetails>
          </Accordion>
        </Accordion>

        <Accordion className='removeBorder AccordionSummaryDiv'>
          <AccordionSummary className='subAccordian'
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            {/* <img src={report} className='reportIcon' alt="report" /> */}
            <ExploreIcon style={{ marginRight: "5%" }} />
            <Typography component={'span'}>Reports</Typography>
          </AccordionSummary>
          {/* {(loginuserroles === 1 || loginuserroles === 3) && */}
            <Accordion className='AccordionSummaryDiv subMenuDiv'>

              <AccordionDetails className='typoEmployer' sx={{padding: '0px !important'}}
                // expandIcon={<ExpandMoreIcon />}
                // aria-controls="panel1a-content"
                // id="panel1a-header"
              >
                 <Typography component={'span'}>
                  <ul className='ulList'>
                    <li>
                      <NavLink to="/report-deduction" activeClassName='active' className='CommonDiv'>
                      <img src={deduction} className='deductionIcon' alt="deduction" /> 
                        <Typography className=' typoTxt' component={'span'} onClick={()=>deductionNavigation()}> Deduction </Typography>
                      </NavLink>
                    </li> 
                  </ul>

                </Typography> 
              </AccordionDetails>
            </Accordion>
          {/* // } */}
        </Accordion>

        <NavLink to="/configuration" activeClassName='active' className='CommonDiv'>
          <SettingsIcon /> <Typography className='dashboardText' component={'span'}> Configuration</Typography>
        </NavLink>

        {/* <NavLink to="/help-docs" activeClassName='active' className='CommonDiv'>
          <HelpIcon /> <Typography className='dashboardText' component={'span'}>Help & Docs</Typography>
        </NavLink> */}

        <NavLink to="/users-feedback/1" activeClassName='active' className='CommonDiv'>
        <img src={UserFeedbackLogo} className='dataExchngeImg' alt="logo" />
          <Typography className='dashboardText' component={'span'}> Users Feedback</Typography>
        </NavLink>

        {(loginuserroles === 1) ? 
        (<NavLink to="/price-management" activeClassName='active' className='CommonDiv'>
          <img src={PriceManagementLogo} className='dataExchngeImg' alt="logo" />
        <Typography className='dashboardText' component={'span'}> Price Management</Typography>
      </NavLink>) : ""}
        

        <NavLink to="/help" activeClassName='active' className='CommonDiv'>
          <HelpIcon /> <Typography className='dashboardText' component={'span'}>Help & Docs</Typography>
        </NavLink>

      </List>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;


  return (
    isLoggedIn ? <Box sx={{ display: 'flex' }} className='TopBox'>
      <CssBaseline />
      <AppBar className='TopBoxAppBar'
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar className='MainToolBar'>
          <IconButton className='pageMenu'
            colodisplayr="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" className='topNavHeaderTypography'>
            <Grid container className='topNavHeader'>
              <Grid item xs={12} sm={4} md={4} className='topNavHeaderFirstGrid'>
                {/* <SearchField
                  placeholder="Search..."
                  classNames="test-class SearchField"
                /> */}
              </Grid>

              <Grid item xs={12} sm={8} md={8} className='profileDivLast'>

                <Grid item xs={8} sm={9} md={10} lg={11} >
                  <Typography className='welcomeTxt'>
                    Hi,  {userInfo.first_name}
                  </Typography>
                  {/* <Typography className='welcomeTxt'>
                    {userInfo.roles == 3 ? 'Employer (' + `${userInfo.employer_code}` + ')' : 'Admin'}
                  </Typography> */}
                </Grid>

                <Grid item xs={4} sm={3} md={2} lg={1}>
                  {/* <PersonIcon className='colorBlue cursorStyle' />
                  <LogoutIcon onClick={() => logout('/login')} className='colorBlue cursorStyle ml-10' /> */}

                  <React.Fragment>
                    <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                      {/* <Typography sx={{ minWidth: 100 }}>Contact</Typography>
                      <Typography sx={{ minWidth: 100 }}>Profile</Typography> */}
                      <Tooltip title="Account settings">
                        <IconButton className='bg-menu'
                          onClick={handleClick}
                          size="small"
                          aria-controls={open ? 'account-menu' : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? 'true' : undefined}
                        >

                          <KeyboardArrowDownIcon className='colorBlue' sx={{ width: 32, height: 32 }} />
                        </IconButton>
                        {/* <PersonIcon className='colorBlue' sx={{ width: 32, height: 32 }}/>  */}
                      </Tooltip>
                    </Box>
                    <Menu
                      anchorEl={anchorEl}
                      id="account-menu"
                      open={open}
                      onClose={handleClose}
                      onClick={handleClose}
                      PaperProps={{
                        elevation: 0,
                        sx: {
                          overflow: 'visible',
                          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                          mt: 1.5,
                          '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                          },
                          '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                          },
                        },
                      }}
                      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    >
                      {/* <MenuItem>
                        <Avatar /> My account
                      </MenuItem> */}
                      <MenuItem onClick={() => goToPageClick('/users-profile')}>
                        <ListItemIcon>
                          <PersonIcon className='colorBlue' sx={{ width: 32, height: 32 }}/>
                        </ListItemIcon>
                        Edit Profile
                      </MenuItem>
                      <MenuItem onClick={() => goToPageClick('/user-change-password')}>
                        <ListItemIcon className='colorBlue'>
                          <LockResetOutlinedIcon />
                        </ListItemIcon>
                        Change Password
                      </MenuItem>
                      <MenuItem onClick={openConfirmDialog}>
                      {/* onClick={() => logout('/login')} */}
                        <ListItemIcon className='colorBlue'>
                          <Logout />
                        </ListItemIcon>
                        Logout
                      </MenuItem>
                    </Menu>
                  </React.Fragment>

                </Grid>

              </Grid>
            </Grid>
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

    </Box> : ''
  );
}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default ResponsiveDrawer;